/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['.mainarea[_ngcontent-%COMP%] {\n  flex: 1;\n  margin-top: -18px; }\n\n.header-area[_ngcontent-%COMP%] {\n  width: 100%;\n  height: 40px;\n  min-height: 40px;\n  flex: 0;\n  background-color: #1D1D1D;\n  z-index: 20; }\n\n.app[_ngcontent-%COMP%] {\n  display: flex;\n  flex-direction: column;\n  height: 100%; }'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3NyYy91aS9zcmMvYXBwL2FwcC5jb21wb25lbnQuc2Nzcy5zaGltLm5nc3R5bGUudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9zcmMvdWkvc3JjL2FwcC9hcHAuY29tcG9uZW50LnNjc3MiXSwic291cmNlc0NvbnRlbnQiOlsiICJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7OyJ9



// WEBPACK FOOTER //
// ./aot_output/src/app/app.component.scss.shim.ngstyle.ts